import { Injectable } from '@angular/core';
import { CanDeactivate, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { ComponentFunctions, ISummitForm } from '@summit/form';
import { SummitDisposing } from '@summit/models';

@Injectable()
export class CanDeactivateGuard extends SummitDisposing implements CanDeactivate<ISummitForm> {
  constructor() {
    super();
  }

  canDeactivate(
    component: ISummitForm
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // console.log('Guard got component: ', component);
    return ComponentFunctions.ValidToUnload(component);
  }
}
